import { BellRing, Share, Loader2, Plus } from 'lucide-react'
import { usePush } from './usePush'
import './push.css'

/**
 * Calm, non-nagging home nudge. Only appears when there's a clear next step:
 *  - `available` → offer to enable alerts (one tap)
 *  - `needs-install` (iOS, not installed) → show Add-to-Home-Screen guidance
 * Stays silent when already subscribed, denied, unsupported, or unconfigured.
 */
export function PushNudge({ locationLabel }: { locationLabel: string }) {
  const { status, busy, error, enable } = usePush()

  if (status === 'available') {
    return (
      <div className="nudge card">
        <div className="nudge__icon">
          <BellRing size={20} />
        </div>
        <div className="nudge__text">
          <p className="nudge__title">Get warned first</p>
          <p className="nudge__sub">Push alerts for {locationLabel} the moment NWS issues a warning.</p>
          {error && <p className="nudge__error">{error}</p>}
        </div>
        <button className="btn btn--primary btn--sm" onClick={enable} disabled={busy}>
          {busy ? <Loader2 size={16} className="spin" /> : <BellRing size={16} />}
          {busy ? 'Enabling…' : 'Enable'}
        </button>
      </div>
    )
  }

  if (status === 'needs-install') {
    return (
      <div className="nudge nudge--install card">
        <div className="nudge__icon">
          <Plus size={20} />
        </div>
        <div className="nudge__text">
          <p className="nudge__title">Install for alerts</p>
          <p className="nudge__sub">
            Tap <Share size={14} className="nudge__inline" /> Share, then{' '}
            <strong>Add to Home Screen</strong> — push alerts work once installed.
          </p>
        </div>
      </div>
    )
  }

  return null
}
